export default __webpack_public_path__ + "static/fullWidth1-d7d90e2931fc225e3dbee772c9ae44dc.png";